import React from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image, Dimensions, TextInput} from "react-native";


import {RFValue} from "react-native-responsive-fontsize";
import {FontAwesome, FontAwesome6, Ionicons} from "@expo/vector-icons";
import Config from "../../Config";
import AntDesign from "@expo/vector-icons/AntDesign";
import Feather from "@expo/vector-icons/Feather";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import * as Linking from 'expo-linking';




const About =({navigation})=>{

    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <TouchableOpacity style={{flex : 1}} >
                    <Text style={styles.title}>
                        درباره ما
                    </Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={()=>{navigation.goBack()}}>
                    <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />
                </TouchableOpacity>
            </View>
            <ScrollView style={{flex:1  , backgroundColor : Config.maincolor}}>
                <View style={styles.content}>
                    <View style={{justifyContent: "center", alignItems: "center"}}>
                        <Image style={styles.image} source={require('../../assets/images/about.png')}/>
                    </View>
                    <Text style={styles.h2}>
                        مأموریت ما:
                    </Text>
                    <Text style={styles.p}>
                        در "هیمورا"، ما به شما کمک می‌کنیم تا به راحتی و با لذت زبان‌های جدید را یاد بگیرید. هدف ما ارائه‌ی یک پلتفرم آموزشی جذاب و کارآمد است که به شما ابزارهای لازم برای تسلط به زبان‌های مختلف را بدهد. ما اعتقاد داریم که یادگیری زبان باید سرگرم‌کننده و بدون استرس باشد!
                    </Text>
                    <Text style={styles.h2}>
                        تاریخچه ما:
                    </Text>
                    <Text style={styles.p}>
                        "هیمورا" در سال ۲۰16 با هدف کمک به زبان‌آموزان مبتدی و پیشرفته تأسیس شد. ما به این فکر کردیم که با استفاده از تکنولوژی و منابع آموزشی متنوع، می‌توانیم فرآیند یادگیری زبان را به تجربه‌ای دلپذیر تبدیل کنیم. از آن زمان تا کنون، اپلیکیشن ما به روزرسانی‌های متعددی داشته و به رشد و پیشرفت خود ادامه داده است.
                    </Text>
                    <Text style={styles.h2}>
                        ویژگی‌های اپلیکیشن:
                    </Text>
                    <View style={styles.ul}>
                        <FontAwesome  name="check" size={RFValue(20)} style={ styles.check  } color="#FFF" />
                        <View style={{flexDirection: "row", width: "90%"}}>
                            <Text style={styles.p}>
                                <Text style={styles.li}>
                                    درس‌های تعاملی:
                                </Text>
                                یادگیری از طریق درس‌های تعاملی و فعالیت‌های آموزشی جذاب.
                            </Text>
                        </View>
                    </View>
                    <View style={styles.ul}>
                        <FontAwesome name="check" size={RFValue(20)} style={ styles.check  } color="#FFF" />
                        <View style={{flexDirection: "row", width: "90%"}}>
                            <Text style={styles.p}>
                                <Text style={styles.li}>
                                    منابع چندرسانه‌ای:
                                </Text>
                                  دسترسی به ویدئوها، پادکست‌ها و مقالات متنوع برای تقویت مهارت‌های شنیداری و خواندن.
                            </Text>
                        </View>
                    </View>
                    <View style={styles.ul}>
                        <FontAwesome name="check" size={RFValue(20)} style={ styles.check  } color="#FFF" />
                        <View style={{flexDirection: "row", width: "90%"}}>
                            <Text style={styles.p}>
                                <Text style={styles.li}>
                                    تمرینات و آزمون‌ها:
                                </Text>
                                 تمرینات متنوع و آزمون‌های آنلاین برای ارزیابی پیشرفت شما.
                            </Text>
                        </View>
                    </View>

                    <Text style={styles.h2}>
                        ارتباط با ما:
                    </Text>
                    <Text style={styles.p}>
                        ما دوست داریم با شما در ارتباط باشیم! اگر سؤالی دارید، نظری دارید یا پیشنهاداتی برای بهبود اپلیکیشن دارید، لطفاً با ما تماس بگیرید:
                    </Text>

                    <TouchableOpacity onPress={()=>Linking.openURL('tel:04433379562')} style={styles.icon}>
                        <Feather style={styles.iconcontainer} name="phone-call" size={RFValue(20)} color={Config.maincolor} />
                        <Text style={styles.p}>
                            04433379562
                        </Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={()=>Linking.openURL('https://www.instagram.com/himora_language_center')}  style={styles.icon}>
                        <AntDesign style={styles.iconcontainer} name="instagram" size={RFValue(20)} color={Config.maincolor} />
                        <Text style={styles.p}>
                            @himora_language_center
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={()=>Linking.openURL('https://himoralanguagecenter.com')} style={styles.icon}>
                        <MaterialCommunityIcons  style={styles.iconcontainer} name="web" size={RFValue(20)} color={Config.maincolor} />
                        <Text style={styles.p}>
                            himoralanguagecenter.com
                        </Text>
                    </TouchableOpacity>









                </View>
            </ScrollView>


        </View>
    );
}

const styles = StyleSheet.create({

    check : {
        backgroundColor :'#33B300' ,
        padding : RFValue(2),
        borderRadius : RFValue(100),
        marginLeft : RFValue(11),

    },

    li : {
        fontFamily : 'ykb',
        fontSize : RFValue(12),
        // marginVertical : RFValue(8),
        color : "#FFF",
    },

    ul : {
      flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems: 'baseline',
        // flexWrap : 'wrap'
    },
    iconcontainer : {
      backgroundColor: Config.secondcolor,
        borderRadius : RFValue(4),
        padding : RFValue(4),
        marginLeft: RFValue(10),
    },
    icon : {
      flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems: 'center',
        paddingVertical: RFValue(6),
    },

    h2 : {
      fontFamily : 'ykb',
      fontSize : RFValue(18),
      marginVertical : RFValue(8),
      color : "#FFF",
    },
    p : {
        fontFamily : 'ykb',
        fontSize : RFValue(12),
        marginVertical : RFValue(8),
        color : "#E4E4E4",
        textAlign: "justify",
    },

    image : {
      width: RFValue(190),
      height: RFValue(170),
        marginBottom : RFValue(30),
    },

    content : {
        flex: 1,
        paddingHorizontal: RFValue(20),

        paddingVertical: RFValue(20),
        backgroundColor :Config.maincolor,
    },

    container : {
        flex: 1,
        backgroundColor: Config.maincolor,
    },
    header: {
        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: '#FFF',
        paddingVertical: RFValue(14),

    },

})


export default About